<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'孵化器发布审核',goback:true},{name:'孵化器发布审核详情'}]" :title="'孵化器发布审核详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="账号信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                     <div class="child">
                      <div class="name">账号：</div>
                      <div class="content">{{ dataInfo.createUserName || '--' }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8" v-if="dataInfo.userVo">
                    <div class="child">
                      <div class="name">账号类型：</div>
                      <div class="content">{{ dataInfo.userVo.userTypeName }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">姓名：</div>
                      <div class="content">{{ dataInfo.createName || '--' }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8" v-if="dataInfo.userVo">
                    <div class="child">
                      <div class="name">邮箱：</div>
                      <div class="content">{{ dataInfo.userVo.email || '--' }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8" v-if="dataInfo.userVo">
                    <div class="child">
                      <div class="name">联系地址：</div>
                      <div class="content">{{ dataInfo.userVo.contactAddress || '--' }}</div>
                    </div>
                  </el-col>
                  
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="孵化器信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">孵化器名称：</div>
                      <div class="content">{{ dataInfo.incubatorName || '--' }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">场地租金：</div>
                      <div class="content">{{ dataInfo.rent || '--' }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">孵化器总面积：</div>
                      <div class="content">{{ dataInfo.area || '--' }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">所在地区：</div>
                      <div class="content">{{ dataInfo.provinceValue + dataInfo.cityValue + dataInfo.areaValue }}</div>
                    </div>
                  </el-col>
                  
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">联系手机号：</div>
                      <div class="content">{{ dataInfo.contactPhone || '--' }}</div>
                    </div>
                  </el-col>
                 </el-row>
                 
                 <el-row>
                  <el-col :span="8">
                   <div class="child">
                    <div class="name">建成时间：</div>
                    <div class="content">{{ dataInfo.createTime || '--' }}</div>
                  </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">简介：</div>
                      <div class="content">{{ dataInfo.remark || '--' }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">孵化器照片：</div>
                      <div class="content" v-show="dataInfo">
                        <div class="content-img" v-for="(img, index) in dataInfo.fileList" :key="index">
                          <div v-if="img.isCover == 1">封面</div>
                          <img style="width: 100%;height: 100%;" :src="dataInfo.frontPath + img.filePath" class="images" />
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                      <div class="child">
                        <div class="name">招商产业：</div>
                        <div class="content">{{ dataInfo.industry || '--' }}</div>
                      </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                      <div class="name">配套设施：</div>
                      <div class="content">{{ dataInfo.facilities || '--' }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                      <div class="name">地理环境：</div>
                      <div class="content">{{ dataInfo.environment || '--' }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                      <div class="name">交通路线：</div>
                      <div class="content">{{ dataInfo.trafficRoutes || '--' }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">其它服务：</div>
                      <div class="content">{{ dataInfo.otherServices || '--' }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">入驻须知：</div>
                      <div class="content">{{ dataInfo.industry || '--' }}</div>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                   <el-col :span="24">
                    <div class="child">
                      <div class="name">详细地址：</div>
                      <div class="content">
                        {{ dataInfo.address }}
                        <div id="mapShow" class="map"></div>
                      </div>
                    </div>
                  </el-col>
                 </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="审核结果" shadow="never" v-if="tab==='2'">
                <el-row>
                    <el-col :span="8">
                      <div class="child">
                              <div class="name">审核结果：</div>
                              <div class="content">{{dataInfo.checkStatusValue}}</div>
                          </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核账号：</div>
                            <div class="content">{{dataInfo.modifyUserName}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{dataInfo.updateTime}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{dataInfo.auditInstructions}}</div>
                        </div>
                    </el-col>
                  </el-row>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            dataInfo:{
               createUserName: "", //账号
                    createName: "",//姓名
                    debtProductName: "",//产品名称
                    loanTypeValue: "",//贷款类型
                    maxAmount: "",//最高额度
                    minAmount: "",//最低额度
                    loanTerm: "",//贷款期限
                    guaranteeWay: "",//担保方式
                    fileList: [],//附件列表
                    yearInterest: '',//年利率
                    productIntro: "",//产品介绍
                    createName: "",//发布账号
                    createTime: "",//发布时间
                    modifyName: "",//发布账号
                    updateTime: "",//发布账号
                    checkStatusValue: '',//审核状态
                    modifyUserName: "",//审核账号
                    updateDate: '',//审核时间
                    checkExplanation: "",//说明
                    loanKnown: [],
                    userVo: {
                        email: "",//邮箱
                        contactAddress: "",//联系地址
                        companyName: "",
                        userName: "",//用户名
                        userTypeName: "",//用户类型
                    }
            },//数据
			debtStatistics:'',//债权融资统计
			financialLeasingStatistics:'',//融资租赁统计
			equityStatistics:'',//股权融资列表统计
			vouchStatistics:'',//担保服务统计
			policyGuidanceStatistics:'',//政策指引统计
			incubatorStatistics:'',//孵化器统计
			activitySalonStatistics:'',//活动沙龙统计
      center: {}, //地图中心点
			maker: {}, //标记点
			zoom: 15, //缩放等级
        }
    },
    methods:{
      ready() {
			let map = new BMap.Map("mapShow");    
			let point = new BMap.Point(this.center.lng, this.center.lat);    
			map.centerAndZoom(point, 16);    
			map.enableScrollWheelZoom(true);
			map.enableDoubleClickZoom(true);
			let marker = new BMap.Marker(point);        // 创建标注    
			map.addOverlay(marker);                     // 将标注添加到地图中 
		},
        open(){
          this.$alert('点击附件')
        },
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('backstage/incubator/review/details/' + this.id)
          if (code == 200) {            
              let dataInfo = data;
              let fileList = dataInfo.fileList;
              if (fileList.length > 0) {
                let fils = [];
                for (let i in fileList) {
                  if (fileList[i].isCover == 1) {
                    fileList[i].isCover = true;
                  } else {
                    fileList[i].isCover = false;
                  }
                }
                dataInfo.fileList = fileList;
              }
              this.dataInfo = dataInfo;
              this.maker = { lng: data.longitude, lat: data.latitude };
              this.center = { lng:data.longitude, lat: data.latitude };
              setTimeout(()=>{
                this.ready()
              },500)
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
  height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>